import { GetPayUpType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeletePayUpPicture = () => {
    const queryClient = useQueryClient()

    return useMutation<
        GetPayUpType,
        Error,
        { tripId: string; payUpId: number; fileId: string }
    >({
        mutationFn: async ({ tripId, payUpId, fileId }) => {
            const response = await api.delete<GetPayUpType>(
                `/trips/${tripId}/payUps/${payUpId}/picture/${fileId}`,
            )
            return response.data
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.payups(variables.tripId) })
            queryClient.invalidateQueries({ queryKey: queryKeys.payup(variables.tripId, variables.payUpId) })
            queryClient.invalidateQueries({ queryKey: queryKeys.files(variables.tripId) })
        },
    })
}
